import { atom } from '@reatom/framework'

import type { DelugeId } from '@root/entities/user-short'

export const profileCoinsModal = atom<{ delugeId: DelugeId } | undefined>(
  undefined,
  'profileCoinsModal',
)
